import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TableComponent} from "../../common/table/table.component";
import {MatTabGroup} from "@angular/material/tabs";
import {FormOptionsLists} from "../../../shared/FormOptionsLists";
import {AuthService} from "../../../services/auth/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {NewGrammarCategoryComponent} from "../new-grammar-category/new-grammar-category.component";
import {NewGrammarEntryComponent} from "../new-grammar-entry/new-grammar-entry.component";
import {EventData} from "../../common/category-tree/category-tree.component";
import {FuncGrammarService} from "../../../services/grammar/func-grammar.service";
import {SearchTriggerObject} from "../../../shared/SearchTrigger";
import {HttpParams} from "@angular/common/http";
import {filter} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {SharedService} from "../../../services/common/shared.service";

@Component({
  selector: 'app-func-grammar',
  templateUrl: './func-grammar.component.html',
  styleUrl: './func-grammar.component.scss',
  standalone: false
})
export class FuncGrammarComponent implements OnInit {

  @ViewChild(TableComponent) tableC: TableComponent;
  @ViewChild('tabs') tabGroup: MatTabGroup;

  @Input() params: HttpParams;


  categoryControl: number = null;
  displayEditingTools = false;

  // checkboxes to add entries to a Sammelmappe, off until the user asks for them
  selectMode = false;

  toggleSelectMode(): void {
    this.selectMode = !this.selectMode;
  }

  displayedColumns: string[];
  resultsLength = 20;

  markdown;

  details: [string, any][];

  isAuthorized: boolean;
  isAdmin: boolean;

  formOptionsLists = new FormOptionsLists();

  reloadRootsTrigger: boolean = false;
  searchTrigger: SearchTriggerObject = {trigger: false, params: new HttpParams()}
  disableTable: boolean = false;

  resetCategoryControl = false;
  resetSearchTrigger = false;

  entryId : number = null;
  categoryId : number = null;
  initialSearchQuery: string = null;


  constructor(protected funcGrammarService: FuncGrammarService,
              protected authService: AuthService,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router,
              private sharedService: SharedService,
              ) {
  }

  ngOnInit() {
    [this.isAuthorized, this.isAdmin] = this.authService.isAuthorizedAndAdmin();
    if (this.displayEditingTools === true && this.isAdmin) {
      this.displayedColumns = this.formOptionsLists.displayedColumnsFuncGrammarEditing;
    } else {
      this.displayedColumns = this.formOptionsLists.displayedColumnsFuncGrammarDetails;
    }
    this.route.queryParams
      .pipe(filter(params => !!params['id'] || !!params['c_id'] || !!params['q']))
      .subscribe((params: HttpParams) => {
        if (params['q']) {
          this.initialSearchQuery = params['q'];
          // clear any previously selected category so it doesn't narrow this deep-linked search
          this.resetCategoryControl = !this.resetCategoryControl;
          this.categoryControl = null;
        }
        this.entryId = params['id'];
        if (this.entryId) {
          // clear any previously selected category so it doesn't hide this deep-linked entry
          this.resetCategoryControl = !this.resetCategoryControl;
          this.categoryControl = null;
          let httpParams = new HttpParams();
          httpParams = httpParams.set('id', this.entryId);
          this.handleSearch(httpParams)
        }
        // category tree is all handled in the tree component
        this.categoryId = params['c_id'];
        if (this.categoryId) {
          // clear the rest of the filter so it doesn't combine with the deep-linked category
          this.resetSearchTrigger = !this.resetSearchTrigger;
          if (this.tableC) {
            this.tableC.sort.active = 'created';
            this.tableC.paginator.pageSize = 25;
            this.tableC.paginator.pageIndex = 0;
          }
        }
        this.sharedService.clearIdParam(this.router);
      });
  }

  toggleEditingTools(change: boolean) {
    if (change) {
      this.displayEditingTools = !this.displayEditingTools;
    }
    if (this.displayEditingTools) {
      this.displayedColumns = this.formOptionsLists.displayedColumnsFuncGrammarEditing;
    } else {
      this.displayedColumns = this.formOptionsLists.displayedColumnsFuncGrammarDetails;
    }
  }

  openNewCategoryDialog() {
    const dialogRef = this.dialog.open(NewGrammarCategoryComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.reloadRootsTrigger = !this.reloadRootsTrigger;
    });
  }

  openNewEntryDialog() {
    const dialogRef = this.dialog.open(NewGrammarEntryComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.searchTrigger.trigger = !this.searchTrigger.trigger
    })
  }

  /*-------------------- Category Tree --------------------*/

  handleChildSearch(data: EventData) {
    if (this.categoryControl !== data.categoryControl) {
      this.categoryControl = data.categoryControl;
      // clear any previously deep-linked/searched entry id so it doesn't stay combined with the new category
      this.entryId = null;
      this.resetSearchTrigger = !this.resetSearchTrigger;
      this.searchTrigger.trigger = !this.searchTrigger.trigger;
    }
  }

  /*-------------------- Search Bar --------------------*/
  handleSearch(params: HttpParams) {
    this.searchTrigger.params = params
  }

  handleResetFilter() {
    this.tableC.sort.active = 'created';
    this.tableC.paginator.pageSize = 25;
    this.tableC.paginator.pageIndex = 0;
    this.resetCategoryControl = !this.resetCategoryControl
    this.categoryControl = null
  }
}
